import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "../../components/ui";
import VoucherForm, { mapVoucherToFormValues } from "./VoucherForm";
import { getVoucherById, updateVoucher } from "./voucherApi";
import "./Voucher.css";

function EditVoucherPage() {
  const navigate = useNavigate();
  const { voucherId } = useParams();
  const [voucher, setVoucher] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const loadVoucher = async () => {
      setLoading(true);
      setError("");
      try {
        const currentVoucher = await getVoucherById(voucherId);
        if (!currentVoucher) {
          setError("Voucher not found.");
          setVoucher(null);
          return;
        }
        setVoucher(currentVoucher);
      } catch (err) {
        setError(
          err.response?.data?.message ||
            err.response?.data ||
            err.message ||
            "Failed to load voucher.",
        );
      } finally {
        setLoading(false);
      }
    };

    loadVoucher();
  }, [voucherId]);

  const handleSubmit = async ({ payload, error: validationError }) => {
    if (validationError) {
      setError(validationError);
      return;
    }

    setError("");
    setSaving(true);
    try {
      await updateVoucher(voucherId, payload);
      navigate("/voucher");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          err.response?.data ||
          err.message ||
          "Failed to update voucher.",
      );
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="voucher-page">
      <div className="voucher-form-shell">
        <div className="voucher-form-header">
          <div>
            <h1 className="page-title">Edit Voucher</h1>
            <p className="page-subtitle">Update an existing active voucher.</p>
          </div>
          <Button variant="ghost" onClick={() => navigate("/voucher")}>
            Back to Vouchers
          </Button>
        </div>

        <div className="voucher-form-card">
          {loading ? (
            <div className="voucher-empty-state">Loading voucher...</div>
          ) : voucher ? (
            <VoucherForm
              key={voucher.id}
              mode="edit"
              initialValues={mapVoucherToFormValues(voucher)}
              error={error}
              saving={saving}
              onCancel={() => navigate("/voucher")}
              onSubmit={handleSubmit}
            />
          ) : (
            <div className="voucher-empty-state">
              {error || "Voucher not found."}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EditVoucherPage;
